const BASE_URL = `${process.env.REACT_APP_SERVER_URL}/api/v2/`;

const getSourceUrl = (
  brandId: string,
  videoId: string,
  token: string,
  userId: string
) => {
  return `ui/brands/${brandId}/videos/${videoId}/webm?token=${token}&user_id=${userId}`;
};

export const prepareSource = (
  brandId: string,
  videoId: string,
  token: string,
  userId: string
): string => {
  return `${BASE_URL}${getSourceUrl(brandId, videoId, token, userId)}`;
};
